export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sseWorker.worker.95b056c8.worker.js");
}
